// import './modules/modernizr-custom';
import Accordions from './modules/accordion';
// import Modals from './modules/modal';
import Tabs from './modules/tabs';
// import Includes from './modules/include';
import AnchorLink from './modules/anchorlink';
import HashUrl from './modules/hash_url';
// import AgreeCheck from './modules/check';
import './modules/carousel';
import Zaiko from './modules/zaiko';
// import ColorCart from './modules/colorcart';
// import Review from './modules/review';
// import './modules/timer';
import '../scss/index.scss';

// // YouCamメイクシミュレーター
// import YouCam from './modules/youcam';
// // API読み込み
// (function (d,k) {
//   var s = d.createElement('script');
//   s.type = 'text/javascript';
//   s.async = true;
//   s.src = 'https://plugins-media.makeupar.com/c317/sdk.js?apiKey=' + k;
//   var x = d.getElementsByTagName('script')[0];
//   x.parentNode.insertBefore(s, x);
// })(document, 'y6xyy2zXnvV8pqT4m49JQ==')

// // ツール初期化
// window.ymkAsyncInit = function() {
//   YMK.init({'autoOpen': true,'language': 'jpn'});
//   window.YMK.addEventListener('loaded', function() {
//     // console.log('loaded!')
//     const vmModal = document.getElementById('modal-vm');
//     if(vmModal){
//       const envBox = vmModal.querySelector('.mod-vmmodal--vmcont_env');
//       const vmBtnBox = vmModal.querySelector('.mod-vmmodal--vmcont_function');
//       envBox.style.display = 'none';
//       vmBtnBox.style.display = 'block';
//     }
//   });
// }

document.addEventListener('DOMContentLoaded',function(){

  // //html include
  // const includeContainers = Array.from(document.querySelectorAll('[data-inc]'));
  // includeContainers.forEach((container) => {
  //   new Includes(container);
  // });

  //在庫制御
  const carts = document.querySelectorAll('.js-zaiko');
  const zaikoFlag = 'zaiko-completed';
  const zaikocb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if(!entry.target.classList.contains(zaikoFlag)){
          new Zaiko(entry.target);
          entry.target.classList.add(zaikoFlag);
        }
        observer.unobserve(entry.target);
      }
    });
  };
  const zaikoIOoptions = {
      root: null,
      rootMargin: "100px",
      threshold: 0
  };
  const zaikoio = new IntersectionObserver(zaikocb, zaikoIOoptions);
  if(carts){
    carts.forEach(cart => zaikoio.observe(cart));
  }

  // // レビューAPI
  // const reviewCont = Array.from(document.querySelectorAll('.js-review'));
  // reviewCont.forEach((cont) => {
  //   new Review(cont);
  // });

  // //Accordion
  const accBtns = Array.from(document.querySelectorAll('.js-acc-btn'));
  accBtns.forEach((accordionBtn) => {
    new Accordions(accordionBtn);
  });

  // //Modal window
  // const modalBtns = Array.from(document.querySelectorAll('.js-modal-open'));
  // modalBtns.forEach((modalBtn) => {
  //   new Modals(modalBtn);
  // });

  // //YouCamメイクシミュレーター
  // const vmModalBtns = Array.from(document.querySelectorAll('.js-vmmodal-open'));
  // vmModalBtns.forEach((modalBtn) => {
  //   new YouCam(modalBtn);
  // });

  // //タブ切り替え
  const tabsBtn = Array.from(document.querySelectorAll('.js-tabs-btn'));
  tabsBtn.forEach((tabBtn) => {
    new Tabs(tabBtn);
  });

  // // 同意チェック
  // const checkboxs = Array.from(document.querySelectorAll('.js-agreecheck-input'));
  // checkboxs.forEach((check) => {
  //   new AgreeCheck(check);
  // });

  function onClick(){
    var clickObj = $(".scClick");
    clickObj.each (function(){
      var clickID = $(this).attr("data-clickID");
      var clickLink = $(this).attr("href");
      $(this).attr("onclick","_sc.gene_click('" + clickID + "','" + clickLink +"');");
    })
  }
  onClick();
  
  window.addEventListener('load',function(){

    // // 色玉在庫制御
    // const colorCarts = Array.from(document.querySelectorAll('.js-colorcart-irodama'));
    // colorCarts.forEach((irodamabtn) => {
    //   new ColorCart(irodamabtn);
    // });

    //smooth anchor
    // 上部固定要素があれば指定する
    const fixedContent = document.querySelector('.mod-fixednav.m-upper');
    //ページ内リンク
    let anchorLinks = Array.from(document.querySelectorAll('a'));
    anchorLinks.forEach((link) => {
      new AnchorLink(link,fixedContent);
      // fixedContentなしVersion
      new AnchorLink(link);
    });
    //ハッシュ付きURLでアクセス
    new HashUrl(fixedContent);
    // fixedContentなしVersion
    new HashUrl();

  });

  var tabs = $(".desc_list a");
  var content = $(".shopping_tabs .js-tabs-cont");
  tabs.click(function() {
    var num = tabs.index(this);
    content.addClass('m-hidden');
    content.removeClass('current');
    content.eq(num).removeClass('m-hidden');
    content.eq(num).addClass('current');
    var contTab = $(".shopping_tabs .js-tabs-btn");
    contTab.removeClass('m-current');
    contTab.eq(num).addClass('m-current');
    return false;
  });
  
  $(window).on('load', function (evt) {
    if(location.hash){
      var loadHash = location.hash;
      $('.js-tabs-cont').each(function () {
        if (loadHash.slice(1) == $(this).attr('id')){
            evt.preventDefault();
            console.log('loadHash:',loadHash);
            var hashTarget = $(loadHash);
            var thisUnit = hashTarget.parents('.js-tabs');
            var thisButtons = thisUnit.find('.js-tabs-btn');
            var buttonCurrentCls = 'm-current';
            var contentsHiddenCls = 'm-hidden';
            var contentsCurrentCls = 'current';
            var thisContents = thisUnit.find('.js-tabs-cont');
            var thisCurrentID = loadHash;
            var fadeTime = 300;
            if (hashTarget.hasClass(contentsHiddenCls)) {
              hashTarget.removeClass(contentsHiddenCls);
              hashTarget.addClass(contentsCurrentCls);
              hashTarget.siblings(thisContents).addClass(contentsHiddenCls);
              thisButtons.each(function () {
                  if ($(this).attr('value') === thisCurrentID) {
                      $(this).addClass(buttonCurrentCls);
                      $(this).parents('div').siblings('div').find('.js-tabs-btn').removeClass(buttonCurrentCls);
                  }
              });
              $(thisCurrentID).fadeIn(fadeTime);
              $("html, body").stop().animate({
                  scrollTop: $(thisCurrentID).offset().top
              }, {
                  duration: fadeTime,
                  easing: "swing"
              })
            }
          }
      });
    }
    
    var tgtNav = $('.mod-fixednav');
    var offTop = $('.sec_select').offset().top;
    var fixclass = 'm-light';
    var hideFlag = 'm-black';
    $(window).on('scroll',function(){
        var scrT = $(window).scrollTop();
        // console.log("scrT:",scrT);
        // console.log("offTop:",offTop);
        if(scrT >= 300 && scrT <= offTop){
            tgtNav.addClass(fixclass);
            if(tgtNav.hasClass(hideFlag)){
                tgtNav.removeClass(hideFlag);
            }
        }else if(scrT > offTop || scrT < 300 ){
            if(!tgtNav.hasClass(hideFlag)){
                tgtNav.addClass(hideFlag);
            }
        }
    });

  });

});



